
export default {
  name: 'XCoinsAgreement',
  layout: 'default',
  head() {
    return {
      title: 'XPPen X-Coins User Agreement',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'XPPen Community X-Coins User Agreement — rules for earning, using, redeeming and managing X-Coins.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'XPPen, X-Coins, Points Agreement, Community',
        },
      ],
    }
  },
  mounted() {
    if (!process.client) return
    try {
      const header = document.querySelector('header')
      const footer = document.querySelector('footer')
      if (header) header.style.display = 'none'
      if (footer) footer.style.display = 'none'
    } catch (e) {}
  },
}
